$(document).ready(function(){

    var $obfuscators = $('.obfuscator');

    if($obfuscators.length){
        $obfuscators.each(function(i){
            var $obfuscator = $($obfuscators[i]);
            var beforeAlpha = $obfuscator.data('contact-name');
            var afterAlpha = "wilhelmsen.com";
            if ($obfuscator.data('contact-company')) {
                afterAlpha = $obfuscator.data('contact-company');
            }
            var concat = beforeAlpha + "@" + afterAlpha;
            var wmarkup = '<a href="mailto:' + concat + '">' + concat + '</a>';
            $($obfuscator).html(wmarkup);
        })
    }

});